import { NormativaI } from "interfaces/Normativa";
import { TipoEfectoI } from "interfaces/TipoEfecto";
import { TipoNormativaI } from "interfaces/TipoNormativa";
import { DocumentacionAdjuntaI } from "./documentacionAdjunta";
import { OrganismoI } from "interfaces/Organismo";
import { AlcanceI } from "interfaces/Alcance";

import { ValidezNacionalI } from "interfaces/ValidezNacionalI";

export interface infoFetchGetNormativaI {
  id: number | string;
  nombre: string;
  tipo: TipoNormativaI;
  fechaPublicacion: Date;
  efecto: TipoEfectoI;
  organismo: OrganismoI;
  documentacionAdjunta: DocumentacionAdjuntaI[];
  alcance: AlcanceI;
  descripcion: string;
  aplicaValidezNacional: boolean;
  normativasArray: NormativaI[];
  validacionesNacionalesArray: ValidezNacionalI[];
}

export interface DocumentoParaPrefirmar {
  nombre: string;
  mimetype: string;
  size: number;
  type: string;
}

export interface infoFetchGetUrlPrefirmadaI {
  documentos: DocumentoParaPrefirmar[];
  requestPath: string;
}

export interface PresignedUrlResponse {
    key: string;      // "documento.pdf-uuid1234.pdf"
    url: string;      // "https://s3.amazonaws.com/...?X-Amz-..."
    nombre: string;   // "documento.pdf"
    type: string;     // "anexo"
}

export interface CreateNormativaJsonDto {
    nombre: string;
    descripcion: string;
    tipo_normativa_id: number;
    tipo_efecto_id: number;
    alcance_id: number;
    organismo_id: number;
    fecha_publicacion: string;
    aplicaValidezNacional: boolean;
    normativas_id?: number[];
    validaciones_nacionales_id?: number[]
    documentacion_adjunta?: { key: string; nombre: string, nombre_real: string, mime_type: string, size: number }[];
    anexos?: { key: string; nombre: string, nombre_real: string, mime_type: string, size: number }[];
}

export interface UpdateNormativaJsonDto extends CreateNormativaJsonDto {
    id: number | string;
    documentacion_eliminar?: (number | string)[];
}


class Normativa implements NormativaI {
  id: number | string;
  nombre: string;
  fechaPublicacion: Date;
  tipoNormativa: TipoNormativaI;
  tipoEfecto: TipoEfectoI;
  organismo: OrganismoI;
  alcance: AlcanceI;
  documentacionAdjunta: DocumentacionAdjuntaI;
  anexo: DocumentacionAdjuntaI[];
  descripcion: string;
  aplicaValidezNacional: boolean;
  normativasArray: NormativaI[];
  validacionesNacionalesArray: ValidezNacionalI[];

  constructor(infoFetch: infoFetchGetNormativaI) {
    this.id = infoFetch.id;
    this.nombre = infoFetch.nombre;
    this.tipoNormativa = infoFetch.tipo;
    this.tipoEfecto = infoFetch.efecto;
    this.fechaPublicacion = new Date(infoFetch.fechaPublicacion);
    this.documentacionAdjunta = infoFetch.documentacionAdjunta.find((doc) => !doc.anexo) as DocumentacionAdjuntaI;
    this.anexo = infoFetch.documentacionAdjunta.filter((doc) => doc.anexo);
    this.organismo = infoFetch.organismo;
    this.alcance = infoFetch.alcance;
    this.descripcion = infoFetch.descripcion;
    this.aplicaValidezNacional = infoFetch.aplicaValidezNacional;
    this.normativasArray = infoFetch.normativasArray;
    this.validacionesNacionalesArray = infoFetch.validacionesNacionalesArray;
  }
}

export const makeNormativa = (infoFetch: infoFetchGetNormativaI) => {
  // console.log("NORMATIVA", { infoFetch });
  return new Normativa(infoFetch);
};
